import React, { Component } from 'react';
import SelectableListBox from '../portal/selectableListBox';
import { Popover, OverlayTrigger } from 'react-bootstrap';

export default class DateFilter extends Component {

    constructor(props) {
        super(props);
        this.buttonRef = `${props.filterId}-button`;
        this.listRef = `${props.filterId}-list`;
        this.state = { isFilterOpen: false };
    }
    
    handleGridFilter = (selectedMonthNumber) => {
        
        this.filterGrid(selectedMonthNumber);
        this.props.afterGridFiltering(selectedMonthNumber);
        this.hideFilter();
    }
    
    filterGrid = (selectedMonthNumber) => {
         
        if(selectedMonthNumber){
            
            this.currentSelectedMonthNumber = selectedMonthNumber;
            this.props.handleFilter({ callback: this.isDateOverSelectedMonthNumber });
        }
        else{
            
            this.props.handleFilter();
        }
    }

    isDateOverSelectedMonthNumber = (date) => {
        
        var selectedDate = new Date();
        selectedDate.setMonth(selectedDate.getMonth() - this.currentSelectedMonthNumber);
        var userLastLoginDate = new Date(date);
        return selectedDate > userLastLoginDate;
    }

    hideFilter = () => {
        this.refs.filterOveray.hide();
    }

    isFilterActive = () => {
        return this.props.gridFiltered || this.state.isFilterOpen;
    }

    setFilterOpen = () => {
        
        this.setFilterVisibility(true) ;
    }

    setFilterClose = () => {
        
        this.setFilterVisibility(false) ;
    }

    setFilterVisibility = (isOpen) => {
        
        this.setState({ isFilterOpen: isOpen }) ;
    }

    render() {
        
        const userGridFilterPopover = (
                
            <Popover id='popover-user-grid-filter' className='user-grid-filter'>
                <SelectableListBox ref={ this.listRef }
                    defaultValue = {this.props.selectedMonthNumber}
                    handleSaveSelectedItem = {this.handleGridFilter}
                    selectableItems = {this.props.selectableItems}
                    submitLabel={this.props.submitLabel}
                    onOpen={this.setFilterOpen}
                    onClose={this.setFilterClose}>
                </SelectableListBox>
            </Popover>
        );
        
        return (
            <OverlayTrigger
                ref='filterOveray'
                trigger='click'
                rootClose
                placement='bottom'
                overlay={userGridFilterPopover}>
                <div className='user-grid-filter'>
                    <span ref={ this.buttonRef } className={ ( this.isFilterActive() ? 'active-' : '') + 'filter-icon'}></span>
                </div>
            </OverlayTrigger>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/users/dateFilter.jsx